module.exports = __webpack_public_path__ + "img/dana v-1.10826ef9.png";